import React from 'react';
import { Navigate } from 'react-router-dom';
import PaymentPlan from '../../../page/pay/paymentPlan';

const PaymentPlanRedirect = () => {
  // localStorage에서 recommendCode 가져오기
  const storedCode = localStorage.getItem('recommend_code');

  // 값이 null도 아니고 빈 문자열도 아닌 경우 → 추천코드 있음
  if (storedCode && storedCode !== 'null' && storedCode === '9999') {
    return <Navigate to="/payment/바른NPL_특전_페이지" replace />;
  }
  if (storedCode && storedCode !== 'null' && storedCode === '8888') {
    return <Navigate to="/payment/공인중개사_특전_페이지" replace />;
  }

  return <PaymentPlan />;
};

export default PaymentPlanRedirect;
